export default __webpack_public_path__ + "static/media/gastro_5.eb0eed28.jpg";